import React, { useState, useEffect } from 'react';

import { get_menu_info } from '../../../actions/menu';

import './index.css';

const links = [
    ['https://nazk.gov.ua/', 'Веб-сайт НАЗК'],
    ['https://wiki.nazk.gov.ua/', 'База знань'],
    ['https://study.nazk.gov.ua', 'Навчальна платформа'],
    ['https://vision.nazk.gov.ua', 'Візія майбутнього'],
    ['/#', 'Повідомити про корупцію'],
    ['https://sanctions.nazk.gov.ua', 'Санкційний портал'],
    ['https://antycorportal.nazk.gov.ua/', 'Антикорпортал'],
    ['https://portal.nazk.gov.ua/login', 'Реєстр декларацій'],
    ['https://corruptinfo.nazk.gov.ua', 'Реєстр корупціонерів']
];

const links_js = [
    {
      "url": "https://nazk.gov.ua/",
      "title": "Веб-сайт НАЗК",
      "id_json": 1
    },
    {
      "url": "https://wiki.nazk.gov.ua/",
      "title": "База знань",
      "id_json": 4
    },
    {
      "url": "https://study.nazk.gov.ua",
      "title": "Навчальна платформа",
      "id_json": 5
    },
    {
      "url": "https://vision.nazk.gov.ua",
      "title": "Візія майбутнього",
      "id_json": null
    },
    {
      "url": "/#",
      "title": "Повідомити про корупцію",
      "id_json": null
    },
    {
      "url": "https://sanctions.nazk.gov.ua",
      "title": "Санкційний портал",
      "id_json": 10
    },
    {
      "url": "https://antycorportal.nazk.gov.ua/",
      "title": "Антикорпортал",
      "id_json": 9
    },
    {
      "url": "https://portal.nazk.gov.ua/login",
      "title": "Реєстр декларацій",
      "id_json": null
    },
    {
      "url": "https://corruptinfo.nazk.gov.ua",
      "title": "Реєстр корупціонерів",
      "id_json": 6
    }
  ];

const links_all = [{"id":1,"title_uk":"\u0412\u0435\u0431\u0441\u0430\u0439\u0442","title_en":"Website","url":"https:\/\/nazk.gov.ua\/","status_id":1,"pos":0},{"id":2,"title_uk":"\u0420\u0435\u0454\u0441\u0442\u0440 \u0434\u0435\u043a\u043b\u0430\u0440\u0430\u0446\u0456\u0439","title_en":"Declaration Register","url":"https:\/\/public.nazk.gov.ua","status_id":1,"pos":1},{"id":4,"title_uk":"\u0411\u0430\u0437\u0430 \u0437\u043d\u0430\u043d\u044c","title_en":"Knowledge Base","url":"https:\/\/wiki.nazk.gov.ua\/","status_id":1,"pos":2},{"id":3,"title_uk":"\u0406\u0421\u041c \u0414\u0410\u041f","title_en":"ISM SACP","url":"https:\/\/dap.nazk.gov.ua\/","status_id":1,"pos":3},{"id":5,"title_uk":"\u041d\u0430\u0432\u0447\u0430\u043b\u044c\u043d\u0430 \u043f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430","title_en":"Educational Platform","url":"https:\/\/study.nazk.gov.ua\/","status_id":1,"pos":4},{"id":6,"title_uk":"\u0420\u0435\u0454\u0441\u0442\u0440 \u043f\u043e\u0440\u0443\u0448\u043d\u0438\u043a\u0456\u0432","title_en":"Register of infringers","url":"https:\/\/corruptinfo.nazk.gov.ua\/","status_id":1,"pos":5},{"id":7,"title_uk":"\u041f\u043e\u0440\u0442\u0430\u043b \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u044c \u0432\u0438\u043a\u0440\u0438\u0432\u0430\u0447\u0456\u0432","title_en":"Whistleblower Reporting Portal","url":"https:\/\/whistleblowers.nazk.gov.ua\/","status_id":1,"pos":6},{"id":8,"title_uk":"\u0417\u0432\u0456\u0442\u0438 \u043f\u043e\u043b\u0456\u0442\u043f\u0430\u0440\u0442\u0456\u0439","title_en":"Political Parties` Reports","url":"https:\/\/politdata.nazk.gov.ua\/","status_id":1,"pos":7},{"id":10,"title_uk":"\u0421\u0430\u043d\u043a\u0446\u0456\u0439\u043d\u0438\u0439 \u043f\u043e\u0440\u0442\u0430\u043b","title_en":"Sanctions Portal","url":"https:\/\/sanctions.nazk.gov.ua\/","status_id":1,"pos":8},{"id":9,"title_uk":"\u041f\u043e\u0440\u0442\u0430\u043b \u0434\u043e\u0431\u0440\u043e\u0447\u0435\u0441\u043d\u043e\u0441\u0442\u0456","title_en":"Integrity Portal","url":"https:\/\/antycorportal.nazk.gov.ua\/","status_id":1,"pos":9}];

const active = 6;

const local_p = 7;

let isLoaded = false;


export function UpperMenu(props){

    const [menu_links, setMenu] = useState(JSON.parse(JSON.stringify(links_all)));


    const setData = (data)=>{

        if(!data) return;
        setMenu(data);
        isLoaded = true;
    };

    useEffect(()=>{
        if(!isLoaded) get_menu_info(setData);
    },[]);


    return(
        <div className="head_prerow">
            <ul>
                {menu_links.map((row, index) => { if(+row.id == local_p) row.url = "#"; return row } ).map( (row, index) => <li className={index == active ? 'active' : ''}><a href={row.url} rel="nofollow" alt={row.title_uk} title={row.title_uk}>{row.title_uk}</a></li>) }
            </ul>
        </div>
    )
}